import { Button, Column, Control, Field } from "@allxsmith/bestax-bulma";
import React, {useEffect, useState} from "react";

function useButtonSelect({ label, initialValue, options, prop, callback, disabled=false, loaded}) {
  const [value, setValue] = useState(initialValue || "");
  useEffect(() => {
    setValue(initialValue);
  }, [loaded]);
  const onChange = e => {
    setValue(e.target.value);
    if (callback) {
      callback(e);
    }
  };

  const buttonSelect = (
    <Column>
      <Field>
        <Control>
          <label className="label">{label}</label>
            {options.map(item => (
              <Button key={item.name}
                      value={item.value}
                      color={value === item.value ? "primary" : ""}
                      onClick={() => onChange({target: {name: prop, value: item.value}})}
                      disabled={disabled}
              >
                {item.name}
              </Button>
            ))}
        </Control>
      </Field>
    </Column>
  );
  return [value, buttonSelect, setValue];
}

export default useButtonSelect;
